import { Check, X } from "lucide-react";

const RULES = [
  { key: "len", label: "At least 12 characters", test: (p) => p.length >= 12 },
  { key: "upper", label: "One uppercase letter (A–Z)", test: (p) => /[A-Z]/.test(p) },
  { key: "lower", label: "One lowercase letter (a–z)", test: (p) => /[a-z]/.test(p) },
  { key: "digit", label: "One digit (0–9)", test: (p) => /[0-9]/.test(p) },
  { key: "symbol", label: "One symbol (! @ # $ % etc.)", test: (p) => /[^A-Za-z0-9]/.test(p) },
];

/** Returns a `score` 0–5 (number of satisfied rules) plus per-rule `checks`. */
export function evaluatePassword(pw) {
  const checks = RULES.map((r) => ({ ...r, ok: r.test(pw || "") }));
  const score = checks.filter((c) => c.ok).length;
  return { checks, score, rulesPassed: score === RULES.length };
}

const LABELS = ["Very weak", "Weak", "Fair", "Good", "Strong", "Excellent"];
const COLORS = ["#B54D4D", "#B54D4D", "#C4A265", "#C4A265", "#4E7A5C", "#4E7A5C"];

export default function PasswordStrength({ password }) {
  const { checks, score } = evaluatePassword(password);
  const label = LABELS[score] || LABELS[0];
  const color = COLORS[score] || COLORS[0];
  return (
    <div data-testid="password-strength" className="mt-3">
      <div className="flex gap-1.5" aria-label="Password strength">
        {[0, 1, 2, 3, 4].map((i) => (
          <div
            key={i}
            className="h-1 flex-1 rounded-full transition-colors duration-300"
            style={{ backgroundColor: password && i < score ? color : "rgba(10,37,64,0.10)" }}
          />
        ))}
      </div>
      <div className="mt-2 flex items-center justify-between text-xs">
        <span className="text-navy/60">Strength</span>
        <span data-testid="password-strength-label" className="font-medium" style={{ color: password ? color : "rgba(10,37,64,0.4)" }}>
          {password ? label : "—"}
        </span>
      </div>
      <ul className="mt-3 space-y-1.5" data-testid="password-rules">
        {checks.map((c) => (
          <li key={c.key} data-testid={`password-rule-${c.key}`} className={`flex items-center gap-2 text-xs transition-colors duration-300 ${c.ok ? "text-navy/80" : "text-navy/45"}`}>
            {c.ok ? <Check className="w-3.5 h-3.5 text-gold" strokeWidth={2.5} /> : <X className="w-3.5 h-3.5 text-navy/30" strokeWidth={2} />}
            <span>{c.label}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
